<template>
  <div class="book-infos">
    <Sbanner :detailInfo="detailOne" :showTitle="true" v-if="detailOne && detailOne.id" />
    <div class="container">
      <div class="bookDetail">
        <loading v-if="loading" />
        <div class="book-detail" v-if="detailOne">
          <div class="book-intro">
            <div class="book-pic">
              <img class="van-image" :src="detailOne.cover_img" />
            </div>
            <div class="book-txt">
              <div class="h3 flex">
                <div class="flex-bd">
                  <h3>{{ detailOne.title }}</h3>
                </div>
                <Actions v-if="detailOne.id" :banner="banner" :view="detailOne.browse_count"
                  :collect="detailOne.collect_count" :like="detailOne.like_count" :row="detailOne" />
              </div>

              <div class="prize flex start" v-if="detailOne.activity_name || detailOne.award">
                <i class="iconfont2 icon2-trophy-fill" v-if="detailOne.award" />
                <template v-if="detailOne.activity_name">
                  <router-link target="_blank" :to="{ path: '/activity/' + detailOne.activity_id }"
                    v-if="detailOne.activity_id">
                    <div class="fonts">{{ detailOne.activity_name || '' }}</div>
                  </router-link>
                  <div class="fonts" v-else>{{ detailOne.activity_name }}</div>
                </template>
                <div class="fonts" :class="detailOne.activity_name && detailOne.award ? 'points' : ''"
                  v-if="detailOne.award">{{ detailOne.award }}</div>
              </div>

              <div class="book-sub">
                <div class="items flex start" v-if="detailOne.author">
                  <span style="width: 100px">责任者/责任方式：</span>
                  <div class="flex-bd" v-html="detailOne.author"></div>
                  </div>
                <div class="items flex start" v-if="detailOne.pub_date"><span>出版时间：</span><em class="flex-bd">{{
                  detailOne.pub_date | formatDate("年月日") }}</em></div>
                <div class="items flex start" v-if="detailOne.pub_house"><span>出版单位：</span><em class="flex-bd">{{
                  detailOne.pub_house }}</em></div>
                <div class="items flex start" v-if="detailOne.submitted_unit"><span>报送单位：</span><em class="flex-bd">{{
                  detailOne.submitted_unit }}</em></div>

                <!-- <div class="items flex start" v-if="detailOne.catId"><span>提供机构：</span><em class="flex-bd">{{ detailOne.catId }}</em></div> -->
                <div class="items flex start" v-if="detailOne.words"><span>字　　数：</span><em class="flex-bd">{{
                  detailOne.words | counts }}</em></div>
                <div class="items flex start" v-if="detailOne.keywords && detailOne.keywords.length">
                  <span>关&nbsp;&nbsp;键&nbsp;&nbsp;词：</span><em class="flex-bd">{{
                    detailOne.keywords.join('，') }}</em>
                </div>
              </div>

              <div class="book-man">
                <div class="book-btn">
                  <p @click="goDetail()">立即阅读</p>
                </div>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="book-other" v-if="detailOne">
          <div class="book-section">
            <div class="book-xtx">
              <p :class="{curr: currIndex == 0}" @click="currIndex = 0">书籍摘要</p>
              <p :class="{curr: currIndex == 1}" @click="currIndex = 1" v-if="authorList && authorList.length">作者简介</p>
            </div>
            <div v-if="currIndex == 0">
              <div class="book-other-box" v-html="detailOne.introduce"></div>
              <div class="book-section" v-if="bookCatelog && bookCatelog.length">
                <div class="book-xtx">
                  <p>目录</p>
                </div>
                <BookCatelog :list="bookCatelog" @changePage="goDetail" />
              </div>
            </div>
            <template v-if="currIndex == 1">
              <div class="book-other-box" v-html="item" v-for="(item, index) in authorList" :key="index"></div>
            </template>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Sbanner from '@/components/sbanner.vue'
import BookCatelog from './literature/components/BookCatelog.vue'
import Actions from './exhibit/components/Actions.vue'
import loading from '@/components/common/loading.vue'
import { countWords } from "@/utils/tools"
export default {
  components: { Sbanner, BookCatelog, Actions, loading },
  name: 'literature-book',
  filters: {
    counts(val) {
      return countWords(val)
    },
  },
  props: {},
  data() {
    return {
      currIndex: 0,
      banner: 6,
      showCon: 1,
      detailOne: null,
      bookCatelog: [],
      id: '',
      loading: false,
      nopage: false,
      showpath: 'http://gdzknewcms.renrentong.cn',
      authorList: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.id = this.$route.params.id
    this.initPage()
  },
  methods: {
    async initPage() {
      const params = {
        id: this.id,
        token: this.$route.params.token
      }
      let res = await this.$api.literatureApi.GetByIdShow(params)
      localStorage.setItem('previewBook', JSON.stringify(res))

      let detailOne = res.data || {}
      detailOne.cover_img = this.setImage(res.showpath, detailOne.cover_img, `?x-oss-process=image/resize,m_fill,w_320,h_552`)
      detailOne.keywords = this.$utils.splitWord(detailOne.keywords);
      detailOne.author = this.$utils.fixedHtmlAuthor(res.artistlist)

      this.detailOne = detailOne

      const artistlist = res.artistlist || []

      this.getBookMenu()
      this.getAuthor(artistlist)
    },
    async getBookMenu() {
      const res = await this.$api.literatureApi.getBookMenuById(this.id)
      const list = res.data || []
      this.bookCatelog = list
    },
    async getAuthor(list) {
      if (list && list.length) {
        let authorList = []
        list.forEach(v => {
          if (v.artist_id) {
            this.$api.artistApi.getOneById({id: v.artist_id}).then(res => {
              const data = res.data || {}
              const intro = this.$utils.formatAuthorIntro(data)
              intro && authorList.push(intro)
            })
          }
        })
        this.authorList = authorList
      }
    },
    goDetail(e) {
      const params = {
        banner: this.banner,
        type: this.detailOne.type_id,
        vid: this.detailOne.id,
        category: 5
      }
      if (this.userInfo && this.userInfo.id) {
        params.user_id = this.userInfo.id
      }
      this.$api.recordApi.addUserAction(params)

      let query = {}
      if (e && e.id) {
        query.catelogId = e.id
      }

      this.$router.push({
        path: "/preview-book/read/" + this.id,
        query,
      })
    },
  },
}
</script>
<style scoped lang="scss"></style>